import React from "react";
import PropTypes from "prop-types";

PelakComponent.propTypes = {
  pelak : PropTypes.string,
}
function PelakComponent({ pelak }) {

  const parsePelak = (pelak) => {
    if (!pelak) return null;

    const part1 = pelak.slice(0, 2);
    const part2 = pelak.slice(2, 3);
    const part3 = pelak.slice(3, 6);
    const part4 = pelak.slice(6);

    return { part1, part2, part3, part4 };
  };

  const parts = parsePelak(pelak);

  if (!parts) {
    return <span>پلاک نامعتبر</span>;
  }

  return (
    <td
      className="text-center py-4 whitespace-nowrap text-sm text-black dark:text-white"
      dir="rtl"
    >
        <span>{parts.part4} {parts.part3} {parts.part2} {parts.part1}</span>
    </td>
  );
}

export default PelakComponent;
